<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-3 searching">
                                <span class="h_page">Laporan Perencanaan</span> <br> <br>
                            </div>
                            <div class="col-md-6">

                            </div>
                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button @click="Printing" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Cetak Data">
                                            <i class="material-icons">print</i>
                                        </button>
                                    </span>
                                    <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card"  id="printMe">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">

                            <!-- <div class="col-md-4">
                                <span class="huruf_input">Unit Kerja</span>
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="unit_kerja"
                                    :initValue="''"
                                    :placeholder="unit_kerja_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            </div>
                            <div class="col-md-4">
                                <span class="huruf_input">Periode Renstra</span>
                                <select @change="getRenstraMisi()" class="form-control show-tick" v-model="id_renstra">
                                    <option value="" >-- Semua Periode --</option>
                                    <option v-for="data in list_Renstra" :key="data.id_renstra" :value="data.id_renstra">{{data.periode}}</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <span class="huruf_input">Misi SKPD</span>
                                <select @change="cari_data()" class="form-control show-tick" v-model="renstra_misi_id">
                                    <option value="" >-- Semua Misi --</option>
                                    <option v-for="data in list_Renstra_Misi" :key="data.renstra_misi_id" :value="data.renstra_misi_id">{{data.uraian}}</option>
                                </select>
                            </div> -->


                        </div>
                        <br>
                        
                        <br>
                        <div class="text-center">
                            <span class="h_judul_lap">VISI</span> <br>
                        </div><br>
                        <!-- ============================== VISI ================================ -->
                            <div class="table-responsive">
                                <table class="table-kiken" style="width: 100%">
                                    <thead>
                                    <tr class="bgcol-success2 kepala_table_f tabel_center">
                                        <th class="text-center" style="width: 100%">VISI</th>
                                    </tr>
                                    </thead>
                                    <tbody class="tabel_center" >

                                        <tr class="h_isitable" >
                                            <td class="tabel_center">Menuju Konawe Selatan Sejahtera, Unggul Dan Amanah Berbasis Perdesaan Tahun 2021</td>
                                        </tr>


                                    </tbody>
                                </table>
                            </div>
                        <!-- ============================== VISI ================================ -->



                        <hr>
                        <div class="text-center">
                            <span class="h_judul_lap">MISI</span> <br>
                        </div><br>

                        <!-- ============================== MISI ================================ -->
                            <div class="table-responsive">
                                <table class="table-kiken" style="width: 100%">
                                    <thead>

                                    <tr class="bgcol-success2 kepala_table_f tabel_center">
                                        <th class="text-center" style="width: 5%">No</th>
                                        <th class=" text-center" style="width: 95%">Misi</th>
                                    </tr>
                                    </thead>
                                    <tbody class="tabel_center" >

                                        <tr class="h_isitable" v-for="data in list_misi" :key="data.misi_id">
                                            <td class="tabel_center text-center">{{data.no_misi}}</td>
                                            <td class="tabel_center">{{data.uraian}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        <!-- ============================== MISI ================================ -->


                        <hr>
                        <div class="text-center">
                            <span class="h_judul_lap">TUJUAN</span>
                        </div><br>

                        <!-- ============================== TUJUAN ================================ -->
                            <div class="table-responsive">
                                <table class="table-kiken" style="width: 100%">
                                    <thead>

                                        <tr class="bgcol-success2 kepala_table_f tabel_center">
                                            <th class="text-center " style="width: 5%">No</th>
                                            <th class=" text-center" style="width: 65%">Misi/Tujuan</th>
                                            <th class=" text-center" style="width: 10%">Indikator</th>
                                            <th class=" text-center" style="width: 10%">Satuan</th>
                                            <th class=" text-center" style="width: 10%">Target</th>
                                        </tr>
                                    </thead>
                                    <tbody class="tabel_center" >
                                        <template v-for="data1 in list_tujuan">
                                            <tr class="h_isitable" :key="data1.misi_id">
                                                <td class="tabel_center bg-success" colspan="5">
                                                    Misi {{data1.no_misi}} : {{data1.uraian_misi}}
                                                </td>
                                            </tr>
                                            <template v-for="data2 in data1.tujuan">
                                                <tr class="h_isitable" :key="data2.tujuan_id">
                                                    <td class="tabel_center text-center">{{data1.no_misi}}.{{data2.no_tujuan}}</td>
                                                    <td class="tabel_center">{{data2.uraian_tujuan}}</td>
                                                    <td class="tabel_center text-center"></td>
                                                    <td class="tabel_center text-center"></td>
                                                    <td class="tabel_center text-center"></td>
                                                </tr>
                                            </template>
                                            
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        <!-- ============================== TUJUAN ================================ -->


                        <hr>
                        <div class="text-center">
                            <span class="h_judul_lap">SASARAN</span> <br>
                        </div><br>

                        <!-- ============================== SASARAN ================================ -->
                            <div class="table-responsive">
                                <table class="table-kiken" style="width: 100%">
                                    <thead>

                                        <tr class="bgcol-success2 kepala_table_f tabel_center">
                                            <th class="text-center " style="width: 5%">No</th>
                                            <th class=" text-center" style="width: 95%">Tujuan/Sasaran</th>
                                        </tr>
                                    </thead>
                                    <tbody class="tabel_center" >
                                        <template v-for="data in list_sasaran">
                                            <tr class="h_isitable" :key="data.tujuan_id">
                                                <td class="tabel_center bg-success" colspan="5">
                                                    Tujuan {{data.no_misi}}.{{data.no_tujuan}} : {{data.uraian_tujuan}}
                                                </td>
                                            </tr>
                                            <template v-for="data1 in data.sasaran">
                                                <tr class="h_isitable" :key="data1.sasaran_id">
                                                    <td class="tabel_center text-center">{{data.no_misi}}.{{data.no_tujuan}}.{{data1.no_sasaran}}</td>
                                                    <td class="tabel_center">{{data1.uraian_sasaran}}</td>
                                                </tr>
                                            </template>
 
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        <!-- ============================== SASARAN ================================ -->


                        <hr>
                        <div class="text-center">
                            <span class="h_judul_lap">INDIKATOR SASARAN</span> <br>
                        </div><br>

                        <!-- ============================== INDIKATOR SASARAN ================================ -->
                            <div class="table-responsive">
                                <table class="table-kiken" style="width: 100%">
                                    <thead>

                                        <tr class="bgcol-success2 kepala_table_f tabel_center">
                                            <th class="text-center " style="width: 5%">No</th>
                                            <th class=" text-center" style="width: 43%">Sasaran/Indikator</th>
                                            <th class="text-center " style="width: 10%">Satuan</th>
                                            <th class="text-center " style="width: 7%">2016</th>
                                            <th class="text-center " style="width: 7%">2017</th>
                                            <th class="text-center " style="width: 7%">2018</th>
                                            <th class="text-center " style="width: 7%">2019</th>
                                            <th class="text-center " style="width: 7%">2020</th>
                                            <th class="text-center " style="width: 7%">2021</th>
                                        </tr>
                                    </thead>
                                    <tbody class="tabel_center" >
                                        <template v-for="data in list_sasaran_indikator" >
                                            <tr class="h_isitable" :key="data.sasaran_id">
                                                <td class="tabel_center bg-success" colspan="9">
                                                    Sasaran {{data.no_misi}}.{{data.no_tujuan}}.{{data.no_sasaran}} : {{data.uraian_sasaran}}
                                                </td>
                                            </tr>
                                            <template v-for="data1 in data.indikator">
                                                <tr class="h_isitable" :key="data1.indikator_id">
                                                    <td class="tabel_center text-center">{{data1.no_indikator}}</td>
                                                    <td class="tabel_center">{{data1.uraian}}</td>

                                                    <td class="tabel_center text-center">{{data1.satuan}}</td>
                                                    <td class="tabel_center text-center">{{data1.thn_1}}</td>
                                                    <td class="tabel_center text-center">{{data1.thn_2}}</td>
                                                    <td class="tabel_center text-center">{{data1.thn_3}}</td>
                                                    <td class="tabel_center text-center">{{data1.thn_4}}</td>
                                                    <td class="tabel_center text-center">{{data1.thn_5}}</td>
                                                    <td class="tabel_center text-center">{{data1.thn_6}}</td>
                                                </tr>
                                                

                                            </template>
                                           
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        <!-- ============================== INDIKATOR SASARAN ================================ -->

                        


                        <!-- ============================================================ MODAL ======================================================================== -->


                        <!-- ============================================================ MODAL ======================================================================== -->
                <!-- ============================================================ MULAI ======================================================================== -->
                    </div>

                </div>

            </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL_MISI = URL_APP+'api/v1/planning_misi/';
    const ADD_URL_TUJUAN = URL_APP+'api/v1/planning_tujuan/';
    const ADD_URL_SASARAN = URL_APP+'api/v1/planning_sasaran_pembangunan/';

    

    const ADD_URL = URL_APP+'api/v1/planning_renstra_sasaran/';
    const ADD_URL_RENSTRA = URL_APP+'api/v1/planning_renstra_renstra/';
    const ADD_URL_RENSTRA_MISI = URL_APP+'api/v1/planning_renstra_misi/';
    const ADD_URL_RENSTRA_TUJUAN = URL_APP+'api/v1/planning_renstra_tujuan/'
    const ADD_URL_UNIT_KERJA = URL_APP+'api/v1/simpeg_unit_kerja/';
    const URL_SERVER = URL_APP;

    const ADD_URL_RPJMD = URL_APP+'api/v1/planning_rpjmd/';


    import Autocomplete from 'vue2-autocomplete-js'

    


    export default {
        name: "planning_rpjmd",
        components: { Autocomplete },
        data() {
            return {
               
                unit_kerja : '',
                unit_kerja_full : '',
                unit_kerja_edit : '',

                list_misi : [],
                list_tujuan : [],
                list_sasaran : [],
                list_sasaran_indikator : [],


                token : localStorage.token,
                URL : URL_SERVER
            };
        },

        mounted() {
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;


            this.getMisi();
            this.getTujaun();
            this.getSasaran();
            this.getSasaranIndikator();


            // localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {







        //TAMBAHAN
            getRPJMD : function(){
                fetch(ADD_URL_RPJMD, {
                    method : 'GET',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    }
                }).then(res => res.json()).then((res_data)=>{
                    this.list_RPJMD = res_data;
                })
            },


            getMisi : function(){
                fetch(ADD_URL_MISI, {
                    method : 'GET',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    }
                }).then(res => res.json()).then((res_data)=>{
                    this.list_misi = res_data;
                })
            },
            getTujaun : function(){
                fetch(ADD_URL_TUJUAN+'lap_tujuan', {
                    method : 'GET',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    }
                }).then(res => res.json()).then((res_data)=>{
                    this.list_tujuan = res_data;
                })
            },
            getSasaran : function(){
                fetch(ADD_URL_SASARAN+'lap', {
                    method : 'GET',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    }
                }).then(res => res.json()).then((res_data)=>{
                    this.list_sasaran = res_data;
                })
            },
            getSasaranIndikator : function(){
                fetch(ADD_URL_SASARAN+'lap_indikator', {
                    method : 'GET',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    }
                }).then(res => res.json()).then((res_data)=>{
                    this.list_sasaran_indikator = res_data;
                })
            },


        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.getRenstra();
                // console.log(obj);
            },
            Printing : function(){
                // printMe
                var elem = document.getElementById("printMe");
                var domClone = elem.cloneNode(true);

                var $printSection = document.getElementById("printSection");

                if (!$printSection) {
                    var $printSection = document.createElement("div");
                    $printSection.id = "printSection";
                    document.body.appendChild($printSection);
                }

                $printSection.innerHTML = "";
                $printSection.appendChild(domClone);
                window.print();

            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            btn_check_data_add : function(){

                if (this.id_renstra != '' && this.renstra_misi_id != '') {
                    this.check_data_add = true;
                    this.getRenstraTujuan(this.renstra_misi_id);
                }
            },
            cek_error_data : function(data, data2){
                if (data == '' || data == null || data == undefined || data2 == '' || data2 == null || data2 == undefined) {
                    return 'background : #ffd9cc'
                } else {
                    return ''
                }
            },
        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
